import React, { useEffect, useState, useContext, useRef } from "react"; // ✅ useRef add kiya
import { Container, Row, Col } from "react-bootstrap";
import Swal from "sweetalert2";
import "../../../assets/css/gcadmin/reviews/AdminReviews.css";
import axios from "axios";
import AppContext from "../../../context/AppContext";
import Pagination from "../../../components/general/pagination/Pagination";
import Loader from "../../../components/general/loader/Loader";

const ITEMS_PER_PAGE = 10; // yahan se page size control hoti hai

/* ── Star Rating ── */
const StarRating = ({ rating }) => (
  <div className="gcAdmin-rv-stars">
    {[1, 2, 3, 4, 5].map((star) => (
      <svg key={star} width="14" height="14" viewBox="0 0 24 24"
        fill={star <= rating ? "#f59e0b" : "none"}
        stroke={star <= rating ? "#f59e0b" : "#d1d5db"}
        strokeWidth="1.5">
        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
      </svg>
    ))}
  </div>
);

/* ── Time Ago ── */
const timeAgo = (dateStr) => {
  if (!dateStr) return "—";
  const diff = Math.floor((Date.now() - new Date(dateStr)) / 1000);
  if (diff < 60)     return `${diff} seconds ago`;
  if (diff < 3600)   return `${Math.floor(diff / 60)} minutes ago`;
  if (diff < 86400)  return `${Math.floor(diff / 3600)} hours ago`;
  if (diff < 604800) return `${Math.floor(diff / 86400)} days ago`;
  return new Date(dateStr).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
};

/* ── Avatar Initials ── */
const AvatarCircle = ({ name }) => {
  const initials = name
    ? name.split(" ").map((w) => w[0]).slice(0, 2).join("").toUpperCase()
    : "?";
  return <div className="gcAdmin-rv-avatar"><span>{initials}</span></div>;
};

/* ── Review Card ── */
const ReviewCard = ({ review, tab, onActivate, onDeactivate, onDelete, index }) => (
  <div className="gcAdmin-rv-card gcAdmin-rv-card-anim" style={{ animationDelay: `${index * 0.06}s` }}>
    <div className="gcAdmin-rv-card-left">
      <AvatarCircle name={review.reviewer_name} />
      <div className="gcAdmin-rv-card-info">
        <div className="gcAdmin-rv-card-name-row">
          <span className="gcAdmin-rv-name">{review.reviewer_name || "Unknown"}</span>
          <span className="gcAdmin-rv-role-dot">•</span>
          <span className="gcAdmin-rv-role">{review.reviewer_role || "User"}</span>
        </div>
        <div className="gcAdmin-rv-card-meta-row">
          <StarRating rating={review.rating} />
          <span className="gcAdmin-rv-time">{timeAgo(review.created_at)}</span>
        </div>
        <p className="gcAdmin-rv-text">{review.review}</p>
      </div>
    </div>

    <div className="gcAdmin-rv-card-actions">

      {/* Pending → Activate + DeActivate + Delete */}
      {tab === "pending" && (
        <>
          <button className="gcAdmin-rv-btn gcAdmin-rv-btn--approve" onClick={() => onActivate(review.id)}>
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
              <path d="M20 6L9 17l-5-5" stroke="currentColor" strokeWidth="2.3" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            Activate
          </button>
          <button className="gcAdmin-rv-btn gcAdmin-rv-btn--reject" onClick={() => onDeactivate(review.id)}>
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2.3" strokeLinecap="round" />
            </svg>
            DeActivate
          </button>
          <button className="gcAdmin-rv-btn gcAdmin-rv-btn--icon-delete" onClick={() => onDelete(review.id)} title="Delete">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
        </>
      )}

      {/* Activate tab → DeActivate + Delete */}
      {tab === "Activate" && (
        <>
          <button className="gcAdmin-rv-btn gcAdmin-rv-btn--reject" onClick={() => onDeactivate(review.id)}>
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2.3" strokeLinecap="round" />
            </svg>
            DeActivate
          </button>
          <button className="gcAdmin-rv-btn gcAdmin-rv-btn--icon-delete" onClick={() => onDelete(review.id)} title="Delete">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
        </>
      )}

      {/* DeActivate tab → Activate + Delete */}
      {tab === "DeActivate" && (
        <>
          <button className="gcAdmin-rv-btn gcAdmin-rv-btn--approve-outline" onClick={() => onActivate(review.id)}>
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
              <path d="M20 6L9 17l-5-5" stroke="currentColor" strokeWidth="2.3" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            Activate
          </button>
          <button className="gcAdmin-rv-btn gcAdmin-rv-btn--icon-delete" onClick={() => onDelete(review.id)} title="Delete">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
        </>
      )}

    </div>
  </div>
);

/* ══════════════════════════════════════════════
   Main — Admin Reviews Page
══════════════════════════════════════════════ */
const AdminReviews = () => {
  const { baseUrl, authToken } = useContext(AppContext);

  const [reviews,     setReviews]     = useState([]);
  // Default tab: (Activate) kyunke default status activate hai
  const [activeTab,   setActiveTab]   = useState("Activate");
  const [searchQuery, setSearchQuery] = useState("");
  const [pageIn,      setPageIn]      = useState(false);
  const [loading,     setLoading]     = useState(false); // ✅ initial API fetch loading
  const [currentPage, setCurrentPage] = useState(1);      // ✅ pagination state

  // ✅ Tab switch / pagination change hone par sirf current page (max 10)
  //    reviews ki chhoti loading dikhane ke liye — pura list dobara load nahi hota
  const [viewLoading, setViewLoading] = useState(false);
  const isFirstRender = useRef(true);

  useEffect(() => {
    setTimeout(() => setPageIn(true), 60);
    loadAllReviews();
    // eslint-disable-next-line
  }, []);

  /* ── Load ALL reviews (student + teacher) from DB ── */
  const loadAllReviews = () => {
    setLoading(true); // ✅
    axios
      .post(
        `${baseUrl}/admin/reviews/loadAllReviews`,
        {},
        { headers: { Authorization: `Bearer ${authToken}` } }
      )
      .then((res) => {
        setLoading(false); // ✅
        if (res.data.success) {
          setReviews(res.data.reviews);
        }
      })
      .catch((err) => { setLoading(false); console.error(err); }); // ✅
  };

  /* ── Filter by tab (DB status: pending / approved / rejected) ── */
  const filtered = reviews.filter((r) => {
    const matchTab    = r.status === activeTab;
    const matchSearch =
      (r.reviewer_name || "").toLowerCase().includes(searchQuery.toLowerCase()) ||
      (r.review        || "").toLowerCase().includes(searchQuery.toLowerCase());
    return matchTab && matchSearch;
  });

  /* ── Paginated slice (jo list ko jayega) ── */
  const paginatedReviews = filtered.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  /* ── Tab/search change hone par page 1 pe reset ── */
  useEffect(() => {
    setCurrentPage(1);
    // eslint-disable-next-line
  }, [activeTab, searchQuery]);

  /* ── ✅ Sirf currently active tab ke current page ke (max 10) reviews
     ki chhoti (400ms) loading dikhayein:
     - Jab tab switch ho (Activate <-> DeActivate)
     - Jab us tab ke andar pagination se dusre page par jayen
     Search change hote hi currentPage bhi 1 pe reset hota hai (upar
     wale effect se), is liye search ko alag se dependency mein dalne
     ki zaroorat nahi — nahi tu har keystroke par loader flicker karega. ── */
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    setViewLoading(true);
    const timer = setTimeout(() => setViewLoading(false), 400);
    return () => clearTimeout(timer);
    // eslint-disable-next-line
  }, [activeTab, currentPage]);

  /* ── Counts ── */
  const ActivateCount =
    reviews.filter((r) => r.status === "Activate").length;

  const DeActivateCount =
    reviews.filter((r) => r.status === "DeActivate").length;

  /* ── Activate → approved ── */
  const handleActivate = (id) => {
    axios
      .post(
        `${baseUrl}/admin/reviews/approve`,
        { review_id: id },
        { headers: { Authorization: `Bearer ${authToken}` } }
      )
      .then((res) => {
        if (res.data.success) {
          setReviews((prev) => prev.map((r) => r.id === id ? { ...r, status: "Activate" } : r));
          Swal.fire({
            icon: "success", title: "Activated!",
            text: "Review activated and published.",
            confirmButtonColor: "#213b52", timer: 2000, timerProgressBar: true,
          });
        }
      })
      .catch((err) => console.error(err));
  };

  /* ── DeActivate → rejected ── */
  const handleDeactivate = (id) => {
    Swal.fire({
      title: "DeActivate this review?",
      text: "This review will be moved to DeActivated list.",
      icon: "warning", showCancelButton: true,
      confirmButtonText: "Yes, DeActivate", cancelButtonText: "Cancel",
      confirmButtonColor: "#e05c5c", cancelButtonColor: "#213b52",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .post(`${baseUrl}/admin/reviews/reject`, { review_id: id },
            { headers: { "Authorization": `Bearer ${authToken}` } }
          )
          .then((res) => {
            if (res.data.success) {
              setReviews((prev) => prev.map((r) => r.id === id ? { ...r, status: "DeActivate" } : r));
              Swal.fire({
                icon: "success", title: "DeActivated!",
                text: "Review deactivated successfully.",
                confirmButtonColor: "#213b52", timer: 2000, timerProgressBar: true,
              });
            }
          })
          .catch((err) => console.error(err));
      }
    });
  };

  /* ── Delete ── */
  const handleDelete = (id) => {
    Swal.fire({
      title: "Delete this review?", text: "This action cannot be undone.",
      icon: "warning", showCancelButton: true,
      confirmButtonText: "Yes, Delete", cancelButtonText: "Cancel",
      confirmButtonColor: "#e05c5c", cancelButtonColor: "#213b52",
    }).then((result) => {
      if (result.isConfirmed) {
        setReviews((prev) => prev.filter((r) => r.id !== id));
        Swal.fire({
          icon: "success", title: "Deleted!", text: "Review deleted successfully.",
          confirmButtonColor: "#213b52", timer: 2000, timerProgressBar: true,
        });
      }
    });
  };

  /* ── Tabs: key = DB status, label = display name ── */
  const tabs = [
    { key: "Activate", label: "Activate" },
    { key: "DeActivate", label: "DeActivate" },
  ];

  // ✅ initial fetch loading + tab/pagination ki chhoti loading dono combine
  const showLoader = loading || viewLoading;

  return (
    <div className={`gcAdmin-rv-page ${pageIn ? "gcAdmin-rv-page--in" : ""}`}>
      <Container fluid className="gcAdmin-rv-container">

        {/* Header */}
        <div className="gcAdmin-rv-header">
          <h2 className="gcAdmin-rv-title">User Reviews</h2>
          <p className="gcAdmin-rv-subtitle">
            Activate, DeActivate, and manage testimonials submitted by students and teachers.
          </p>
        </div>

        {/* Stats */}
        <Row>
          <Col xs={12} sm={6}>
            <div className="gcAdmin-rv-stat-card">
              <span className="gcAdmin-rv-stat-label">ACTIVATE</span>
              <span className="gcAdmin-rv-stat-count gcAdmin-rv-stat-count--Activate">
                {ActivateCount}
              </span>
            </div>
          </Col>

          <Col xs={12} sm={6}>
            <div className="gcAdmin-rv-stat-card">
              <span className="gcAdmin-rv-stat-label">DEACTIVATE</span>
              <span className="gcAdmin-rv-stat-count gcAdmin-rv-stat-count--DeActivate">
                {DeActivateCount}
              </span>
            </div>
          </Col>
        </Row>
        {/* Toolbar */}
        <div className="gcAdmin-rv-toolbar">
          <div className="gcAdmin-rv-tabs">
            {tabs.map((tab) => (
              <button
                key={tab.key}
                className={`gcAdmin-rv-tab ${activeTab === tab.key ? "gcAdmin-rv-tab--active" : ""}`}
                onClick={() => { setActiveTab(tab.key); setSearchQuery(""); }}
              >
                {tab.label}
              </button>
            ))}
          </div>

          <div className="gcAdmin-rv-search-wrap">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" className="gcAdmin-rv-search-icon">
              <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="1.9" />
              <path d="M21 21l-4.35-4.35" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" />
            </svg>
            <input
              type="text"
              className="gcAdmin-rv-search"
              placeholder="Search reviews..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
        </div>

        {/* List — ✅ ab showLoader use ho raha hai */}
        {showLoader ? (
          <Loader
            message={loading
              ? "Reviews loading, please wait..."
              : `${tabs.find(t => t.key === activeTab)?.label} reviews loading...`}
          />
        ) : (
          <>
            <div className="gcAdmin-rv-list">
              {filtered.length === 0 && (
                <div className="gcAdmin-rv-empty">
                  <svg width="38" height="38" viewBox="0 0 24 24" fill="none">
                    <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"
                      stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                  <p>No {tabs.find(t => t.key === activeTab)?.label} reviews found.</p>
                </div>
              )}

              {paginatedReviews.map((review, i) => (
                <ReviewCard
                  key={review.id}
                  review={review}
                  tab={activeTab}
                  index={i}
                  onActivate={handleActivate}
                  onDeactivate={handleDeactivate}
                  onDelete={handleDelete}
                />
              ))}
            </div>

            <Pagination
              currentPage={currentPage}
              totalItems={filtered.length}
              itemsPerPage={ITEMS_PER_PAGE}
              onPageChange={setCurrentPage}
            />
          </>
        )}

      </Container>
    </div>
  );
};

export default AdminReviews;